module.exports = __webpack_public_path__ + "img/img_camera_empty.0be1f83c.png";